




















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'

@Component({
  components: { RespondecoResponsiveImage },
})
export default class ProjectHeaderImage extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly project!: ProjectViewModel

  get images() {
    return (
      this.project.resources
        .find(resource => resource.name === 'header')
        ?.resources.map(resource => resource.location) ?? []
    )
  }
}
